// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

import { approvalTypeLabel } from "../../request-center.functions";

export class Controller {
    /** @ngInject */
    constructor(ApprovalPoliciesService, ConfirmDeleteModal, $state) {
        this.ApprovalPoliciesService = ApprovalPoliciesService;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.$state = $state;
    }

    $onInit() {
    }

    createNewPolicy() {
        this.isAdding
        this.ApprovalPoliciesService.createNewPolicy(this.companyId)
            .then((data) => {
                this.$state.go('^.edit',{policyId: data.id}, {reload: '^'});
            })
            .finally(() => this.isAdding = false);
    }

    approvalTypeLabel(policy) {
        return approvalTypeLabel(policy.approvalType);
    }

    removePolicy(policy) {
        this.ConfirmDeleteModal('Are you sure you want to delete this approval policy')
            .then(() => {
                this.isRemoving = policy;
                this.ApprovalPoliciesService.deletePolicy(policy.id, this.companyId)
                    .then(() => this.$state.reload('company.request-center'))
                    .finally(() => this.isRemoving = null);
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/policies/list/approval-policies-list.controller.js